import { Box, Button, Text, Title } from '@nimbus-ds/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';

interface PaymentOptionListEmptyProps {
  handleGoToPayments: () => void;
}

export function PaymentOptionListEmpty({
  handleGoToPayments,
}: Readonly<PaymentOptionListEmptyProps>): JSX.Element {
  const t = useTranslationMarketing(
    'promotions.settingsPage.limits.paymentOptions.modal',
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      gap="3"
      paddingTop="5"
    >
      <Title as="h4">{t('empty.title')}</Title>
      <Text color="neutral-textLow">{t('empty.text')}</Text>
      <Button appearance="primary" onClick={handleGoToPayments}>
        {t('empty.ctaText')}
      </Button>
    </Box>
  );
}
